/* ── Mekeni Bottle Animation v2 ──────────────────────────────
   Same as mekeni-bottle-animation.js but drives the embedded
   #mk-hero-overlay (and the site header) instead of the separate
   #shopify-section-hero fixed overlay.
   Scroll progress (0→1): (scrollY - anchor.offsetTop) / SCROLL_BUDGET
   ───────────────────────────────────────────────────────────── */

(function initBottleAnimationV2() {

  var section    = document.getElementById('bottle-anim-section');
  var bottle     = document.getElementById('bottle-anim-bottle');
  var glow       = document.getElementById('bottle-anim-glow');
  var ring       = document.getElementById('bottle-anim-ring');
  var copyPanel  = document.getElementById('mk-copy-panel');
  var ctaPanel   = document.getElementById('mk-cta-panel');
  var header     = document.querySelector('.site-header');

  if (!section || !bottle || !glow || !ring) return;

  /* Scroll budget: animate over 120vh (p=0→1), anchored to this section's offsetTop.
     The intro track is 200vh, so the section starts at ~200vh. Total: 200+220=420vh page height. */
  var SCROLL_BUDGET = window.innerHeight * 1.2;

  /* ── Constants — verbatim from Mekeni Scroll Animation.html ── */
  var SHELL_COUNT  = 12;
  var SPIN_SPEED   = 11;      /* deg/sec */
  var SIL_OUTWARD  = 1.04;
  var START_H      = 0.34;
  var END_H        = 0.70;

  /* Mobile-responsive values are computed per frame inside frame() so that
     window.innerWidth always reflects the current viewport (handles resize
     in the theme editor preview and orientation changes on device). */

  var SILHOUETTE = [
    0.4904,0.4838,0.4791,0.4742,0.4716,
    0.4678,0.4632,0.4521,0.4272,0.1499,
    0.1520,0.1537,0.1566,0.1595,0.1633,
    0.1671,0.1717,0.1772,0.1833,0.1908,
    0.1987,0.2082,0.2190,0.2314,0.2456,
    0.2625,0.2810,0.3034,0.3283,0.3561,
    0.3860,0.4147,0.4414,0.4658,0.4849,
    0.5003,0.5128,0.5226,0.5293,0.5316,
    0.5307,0.5284,0.5252,0.5215,0.5160,
    0.5113,0.5073,0.5038,0.5012,0.5012,
    0.5000,0.5012,0.5035,0.5061,0.5104,
    0.5157,0.5206,0.5252,0.5290,0.5325,
    0.5328,0.5287,0.5218,0.5131,0.5026,
    0.4916,0.4800,0.4666,0.4524,0.4379,
    0.4220,0.4040,0.3878,0.3712,0.3561,
    0.3416,0.3283,0.3167,0.3057,0.2950,
    0.2860,0.2764,0.2671,0.2573,0.2480,
    0.3025,0.3747,0.4223,0.4626,0.4968,
    0.5168,0.5258,0.5278,0.5258,0.5218,
    0.5180,0.5133,0.5087,0.5035,0.4971
  ];

  var DEG = Math.PI / 180;

  function silRadius(deg) {
    var n    = SILHOUETTE.length;
    var a    = ((deg % 360) + 360) % 360;
    var f    = (a / 360) * n;
    var i0   = Math.floor(f) % n;
    var i1   = (i0 + 1) % n;
    var frac = f - Math.floor(f);
    return SILHOUETTE[i0] * (1 - frac) + SILHOUETTE[i1] * frac;
  }

  function clamp(n, a, b) { return Math.min(b, Math.max(a, n)); }
  function lerp(a, b, t)  { return a + (b - a) * t; }
  function easeOut(t)     { return 1 - Math.pow(1 - t, 3); }

  /* ── Build sunshell slots ─────────────────────────────────
     IMPORTANT: slot must have explicit width/height.
     Shopify's global img { max-width: 100% } collapses img to 0 if the
     slot has no dimensions. max-width:none on img is a second safety net. */
  var sunshellSrc = section.dataset.sunshell;

  for (var i = 0; i < SHELL_COUNT; i++) {
    var slot = document.createElement('div');
    slot.style.cssText =
      'position:absolute;left:0;top:0;width:11vh;height:11vh;';

    var img = document.createElement('img');
    img.src = sunshellSrc;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.style.cssText =
      'position:absolute;left:0;top:0;width:11vh;height:11vh;' +
      'max-width:none;max-height:none;' +
      'transform:translate(-50%,-50%) scale(0.35);opacity:0;' +
      'will-change:transform,opacity;';

    slot.appendChild(img);
    ring.appendChild(slot);
  }

  /* ── Animation state ── */
  var spinAccum = 0;
  var lastTime  = null;

  function frame(now) {
    if (lastTime === null) lastTime = now;
    var dt   = Math.min(0.05, (now - lastTime) / 1000);
    var time = now / 1000;
    lastTime = now;

    /* Re-check viewport on every frame so resize/orientation changes apply */
    var isMobile  = window.innerWidth <= 768;
    var startH    = isMobile ? 0.319 : START_H;
    var endH      = isMobile ? 0.725 : END_H;
    var shellSize = isMobile ? 7 : 11;   /* vh */
    var outward   = isMobile ? 0.72 : SIL_OUTWARD;

    var p = clamp((window.scrollY - section.offsetTop) / SCROLL_BUDGET, 0, 1);
    var e = p * (2 - p);

    /* ── Bottle size + float / tilt ── */
    var floatAmp = clamp((p - 0.9) / 0.1, 0, 1);
    var bob   = Math.sin(time * 0.85) * 1.1 * floatAmp;
    var tilt  = Math.sin(time * 0.55 + 0.7) * 1.3 * floatAmp;
    var hvh   = lerp(startH, endH, e) * 100;
    var drift = lerp(-2, 1, e);

    bottle.style.height    = hvh + 'vh';
    bottle.style.width     = 'auto';
    bottle.style.maxWidth  = isMobile ? '80vw' : 'none';
    bottle.style.transform =
      'translate(-50%, calc(-50% + ' + (drift + bob).toFixed(3) + 'vh)) rotate(' + tilt.toFixed(3) + 'deg)';

    /* ── Glow breathe ── */
    var breathe = 1 + Math.sin(time * 0.85) * 0.04 * floatAmp;
    glow.style.opacity   = (0.25 + 0.55 * e).toFixed(3);
    glow.style.transform =
      'translate(-50%,-50%) scale(' + (lerp(0.7, 1.25, e) * breathe).toFixed(3) + ')';

    /* ── Sunshell ring ── */
    var slots      = ring.children;
    var N          = slots.length;
    var spinFactor = clamp((p - 0.92) / 0.08, 0, 1);
    spinAccum += dt * SPIN_SPEED * spinFactor;
    var phase = e * 6 + spinAccum;

    for (var j = 0; j < N; j++) {
      var ang = (j / N) * 360 + phase;
      var rad = silRadius(ang) * hvh * outward;
      var rx  = Math.sin(ang * DEG) * rad;
      var ry  = -Math.cos(ang * DEG) * rad;
      slots[j].style.transform = 'translate(' + rx.toFixed(2) + 'vh, ' + ry.toFixed(2) + 'vh)';

      var localStart = 0.08 + (j / N) * 0.7;
      var localEnd   = localStart + 0.16;
      var sp  = clamp((p - localStart) / (localEnd - localStart), 0, 1);
      var es  = sp * (2 - sp);
      var shellImg = slots[j].firstElementChild;
      if (shellImg) {
        shellImg.style.width     = shellSize + 'vh';
        shellImg.style.height    = shellSize + 'vh';
        shellImg.style.opacity   = (0.82 * es).toFixed(3);
        shellImg.style.transform =
          'translate(-50%,-50%) scale(' + lerp(0.35, 1, es).toFixed(3) + ')';
      }
    }

    /* ── Hero panels + header fade-in (p 0.88→1.0) ──
       localP maps the 0.88→1.0 window to 0→1.
       Copy panel enters from left first; CTA enters from right 7% later.
       Matches initHeroScroll timing in mekeni.js exactly. */
    var localP = clamp((p - 0.88) / 0.12, 0, 1);

    if (copyPanel) {
      var copyP = clamp(localP / 0.75, 0, 1);
      var ep    = easeOut(copyP);
      copyPanel.style.opacity       = String(ep);
      copyPanel.style.transform     = isMobile
        ? 'none'
        : 'translate(' + lerp(-28, 0, ep).toFixed(2) + 'px, -50%)';
      copyPanel.style.pointerEvents = ep > 0.5 ? 'auto' : 'none';
      copyPanel.style.visibility    = ep > 0 ? 'visible' : 'hidden';
    }

    if (ctaPanel) {
      var ctaP   = clamp((localP - 0.07) / 0.93, 0, 1);
      var ep_btn = easeOut(ctaP);
      /* opacity < 1 on an ancestor disables the button's backdrop-filter
         (glass goes flat) — snap to 1 once the fade is visually done */
      ctaPanel.style.opacity       = ep_btn >= 0.85 ? '1' : String(ep_btn);
      ctaPanel.style.transform     = isMobile
        ? 'none'
        : 'translate(' + lerp(28, 0, ep_btn).toFixed(2) + 'px, -50%)';
      ctaPanel.style.pointerEvents = ep_btn > 0.5 ? 'auto' : 'none';
      ctaPanel.style.visibility    = ep_btn > 0 ? 'visible' : 'hidden';
    }

    /* ── Header fade-in (same timing as copy panel) ── */
    var heroFade = easeOut(clamp(localP / 0.75, 0, 1));
    if (header) {
      header.style.opacity       = heroFade.toFixed(3);
      header.style.visibility    = heroFade > 0 ? 'visible' : 'hidden';
      header.style.pointerEvents = heroFade > 0.5 ? 'auto' : 'none';
    }

    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);

})();
